<template lang="pug">
  .component-selectize-driver
    selectize(v-if="options",
      :disabled="disabled",
      :selectedValue="selectedValue",
      :options="options",
      value-field="id",
      :maxItems="maxItems" label-field="name",
      :items="items" :searchField="searchableFields",
      :optionTemplate="optionTemplate",
      :renderTemplate="renderTemplate",
      @itemAdded="optionSelected",
      @itemRemoved="optionRemoved",
      placeholder="Driver")
</template>

<script>
  import Selectize from '../../../Selectize'
  import BaseSelectize from './BaseSelectize'
  import KeplerBackofficeSdk from '../../../../../lib/kepler/backoffice'

  export default {
    name: 'SelectizeDriver',
    extends: BaseSelectize,
    components: {Selectize},
    data() {

      return {
        searchableFields: ['id', 'name', 'surname', 'username']
      }
    },
    created() {

      if (this.clientDrivers.length > 0) {
        this.options = this.clientDrivers
        return
      }
      KeplerBackofficeSdk.selects.drivers((data) => {
        this.options = data
      })
    },
    methods: {
      optionTemplate(item, escape) {
        return `<div><div>D${item.id} - ${item.name} ${item.surname}</div><div><small>Username: ${item.username}</small></div></div>`
      },
      renderTemplate(item, escape) {
        return `<div><div><small>D${item.id}</small></div> <div>${item.name} ${item.surname}</div></div>`
      }
    },
    props: {
      clientDrivers: {
        type: Array,
        required: false,
        default: function () {
          return []
        }
      },
      selectedValue: {}
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// SelectizeDriver.vue?5309d002